import { Stack } from "@mui/material";
import { useStore } from "zustand";
import { ValidationField } from "@designboticteam/react/components";
import { Section } from "@/components/Section";
import { useEngineApi } from "@/engine";

const DrawingToolsValidationSection = (): React.ReactNode => {
	const api = useEngineApi();

	const validationStatus = useStore(api.kolega3D.store, (store) => store.validationStatus);

	return (
		<Section title="Steps checklist" isCollapsible={true}>
			<Stack direction="column" spacing={1}>
				<ValidationField value={validationStatus.isProjectAreaSet} label="Project center and radius must be set." />

				<ValidationField value={validationStatus.hasCheckZone} label="At least one CheckZone is required." />

				{validationStatus.hasCheckZone && (
					<>
						<ValidationField value={validationStatus.areBuildingZonesValid} label="All BuildingZone vertices are inside a CheckZone." />
						<ValidationField value={validationStatus.areCheckZonesValid} label="Each CheckZone must contain a BuildingZone." />
					</>
				)}
			</Stack>
		</Section>
	);
};

export { DrawingToolsValidationSection };
